<script setup lang="ts">
import { FormInputRating } from "../types";

/////////////////////////////////////////////////////////////
//////////////////////// PROPS //////////////////////////////
/////////////////////////////////////////////////////////////
const props = defineProps<{
  config: FormInputRating;
  modelValue: number;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: string | number): void;
}>();

/////////////////////////////////////////////////////////////
////////////////////// COMPUTED /////////////////////////////
/////////////////////////////////////////////////////////////
const value = computed({
  get: () => props.modelValue,
  set: (value: string | number) => emit("update:modelValue", value),
});

/////////////////////////////////////////////////////////////
////////////////////// METHODS //////////////////////////////
/////////////////////////////////////////////////////////////
</script>

<template>
  <h4 class="mb-3">{{ config.label }}</h4>
  <VRating
    v-model="value"
    :label="config.label ? $t(config.label) : undefined"
    :color="config.color"
    :hover="config.hover"
    :length="config.length"
    size="large"
    :disabled="disabled"
  />
</template>
